































import Vue from 'vue'
export default Vue.extend({
    data: () => ({
        hostingColumns: [
            {
                title: '1. Submit the form',
                description:
                    'Provide the area code you want to backorder a phone number for.'
            },
            {
                title: '2. Wait for backorder',
                description:
                    'Wait 1-5 business days. Our Numbers Team will reach out directly with a timeline'
            },
            {
                title: '3. Use your phone number',
                description:
                    'Send and receive texts with MessageDesk. Make and receive calls with your new phone number'
            }
        ]
    })
})
